import axios from 'axios';

const UrlInputProxy = (inputUrl) => {
  // requesting data from server
  let axiosPromise = axios.post('/.netlify/functions/api/getData', { data: inputUrl }, { timeout: 10000 });

  axiosPromise = axiosPromise.then(serverData => serverData.data);

  // returning promise so that client code can attach `then` and `catch` handler
  return axiosPromise;
};

export default UrlInputProxy;
